import { useEffect, useState } from 'react';
import core from '@gin-betting/core';
import responsiveComponents from '@gin-betting/responsive-components';
import competitorBg from 'assets/competitor-bg';
import sportBg from 'assets/sport-bg';
import tournamentBg from 'assets/tournament-bg';

const { useResponsiveContainer } = responsiveComponents;
const {
    utils: { getIdsFromCompetitorId },
} = core;

interface Input {
    competitorIds: string[];
    tournamentId: string;
    sportId: string;
}

interface Output {
    bg: string | null;
    containerRef: (node: Element | null) => void;
}

export default function useSportEventBg({
    competitorIds: competitorIdPaths,
    tournamentId,
    sportId,
}: Input): Output {
    const [bg, setBg] = useState<null | string>(null);
    const { containerRef, currentBreakpoints, node } = useResponsiveContainer({
        breakpoints: { medium: 440 },
    });

    const isMobile: null | boolean = node
        ? !currentBreakpoints.includes('medium')
        : null;

    const competitorIds = competitorIdPaths.map(
        id => getIdsFromCompetitorId(id).competitorId
    );

    useEffect(() => {
        if (isMobile === null) return;

        let isMounted = true;

        (
            competitorBg(competitorIds, isMobile) ||
            tournamentBg([tournamentId], isMobile) ||
            sportBg([sportId], isMobile)
        )?.then(image => {
            if (!isMounted || !image) return;

            setBg(image);
        });

        return () => {
            isMounted = false;
        };
    }, [competitorIds, tournamentId, sportId, isMobile]);

    return {
        containerRef,
        bg,
    };
}
